import React from 'react';

import TicketTypeSettings from './components/TicketTypeSettings';

/** プライベートチケット設定画面（全ユーザーが自分の設定を操作可） */
const PrivateTicketTypeSettings: React.FC = () => {
  // プライベートは本人所有のため常に操作可（canManageGlobal は不使用だが true を渡す）
  return <TicketTypeSettings scope="PRIVATE" canManageGlobal />;
};

export default PrivateTicketTypeSettings;
